import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/LoginSignup.css";

function Login({ setLoggedIn }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError("Please fill all fields.");
      return;
    }

    const users = JSON.parse(localStorage.getItem("users")) || [];
    const user = users.find(u => u.email === email && u.password === password);

    if (user) {
      localStorage.setItem("loggedInUser", JSON.stringify(user));
      setLoggedIn(true);   
      navigate("/account"); 
    } else {
      setError("Invalid email or password.");
    }
  };

  return (
    <div className="login-page">
      <h2>Login to ShopSphere</h2>

      {/* Login Form */}
      <form className="login-form" onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit">Login</button>
      </form>

      {/* Error Message */}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* Signup Link */}
      <p>
        Don't have an account? <Link to="/signup">Sign up here</Link>
      </p>
      
    </div>
  );
}

export default Login;